module.exports = __webpack_public_path__ + "static/media/leaves.ead698e2.svg";